export default __webpack_public_path__ + "static/media/lb-sg.56c1b786.webp";